import { Row, Col } from 'react-bootstrap'
import { ChatIcon, DocumentIcon, CodeIcon, RocketIcon } from './Icons'

const HowWeWork = () => {
    const steps = [
        {
            icon: <ChatIcon size={40} />,
            number: "01",
            title: "Client Consultation",
            description: "We begin with a detailed discussion to understand your business needs, goals, and technical requirements."
        },
        {
            icon: <DocumentIcon size={40} />,
            number: "02",
            title: "Proposal & Contract",
            description: "We provide a detailed proposal outlining scope, timeline, and milestone-based payment structure."
        },
        {
            icon: <CodeIcon size={40} />,
            number: "03",
            title: "Development Phase",
            description: "Our team executes the project with regular progress updates and milestone reviews."
        },
        {
            icon: <RocketIcon size={40} />,
            number: "04",
            title: "Delivery & Support",
            description: "Final delivery includes documentation, training, and optional ongoing support packages."
        }
    ]

    return (
        <Row className="howWeWork mx-0" id="how-we-work">
            <Row className="mx-0">
                <div className="sectionTitle reveal">
                    How We Work
                </div>
            </Row>
            <Row className="mx-0">
                <div className="sectionDescription reveal">
                    Our structured process ensures transparency and successful project delivery.
                </div>
            </Row>
            <Row className="processSteps mx-0 justify-content-center">
                {steps.map((step, index) => (
                    <Col key={index} className="processStep col-12 col-md-6 col-lg-3 reveal">
                        <div className="processStepInner">
                            <div className="stepIcon">{step.icon}</div>
                            <div className="stepNumber">{step.number}</div>
                            <h3 className="stepTitle">{step.title}</h3>
                            <p className="stepDescription">{step.description}</p>
                        </div>
                    </Col>
                ))}
            </Row>
        </Row>
    )
}

export default HowWeWork
